import { createSvgIcon } from '@mui/material';

export const NewTabIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M20 12.8889v5.3333c0 .4715-.1873.9237-.5207 1.2571-.3334.3334-.7856.5207-1.2571.5207H5.77778c-.4715 0-.92368-.1873-1.25708-.5207C4.1873 19.1459 4 18.6937 4 18.2222V5.77778c0-.4715.1873-.92368.5207-1.25708C4.8541 4.1873 5.30628 4 5.77778 4h5.33332M20 4l-8 8m8-8h-5.3333M20 4v5.33333"
    />
  </svg>,
  'NewTabIcon',
);
